// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file osmosis/incentives/tx.proto (package dymensionxyz.dymension.incentives, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { QueryCondition } from "../../lockup/proto/lock_pb";
import { Coin } from "../../lockup/proto/coin_pb";

/**
 * MsgCreateGauge creates a gague to distribute rewards to users
 *
 * @generated from message dymensionxyz.dymension.incentives.MsgCreateGauge
 */
export const MsgCreateGauge = proto3.makeMessageType(
  "dymensionxyz.dymension.incentives.MsgCreateGauge",
  () => [
    { no: 1, name: "is_perpetual", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribute_to", kind: "message", T: QueryCondition },
    { no: 4, name: "coins", kind: "message", T: Coin, repeated: true },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "num_epochs_paid_over", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.incentives.MsgCreateGaugeResponse
 */
export const MsgCreateGaugeResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.incentives.MsgCreateGaugeResponse",
  [],
);

/**
 * MsgAddToGauge adds coins to a previously created gauge
 *
 * @generated from message dymensionxyz.dymension.incentives.MsgAddToGauge
 */
export const MsgAddToGauge = proto3.makeMessageType(
  "dymensionxyz.dymension.incentives.MsgAddToGauge",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gauge_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "rewards", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.incentives.MsgAddToGaugeResponse
 */
export const MsgAddToGaugeResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.incentives.MsgAddToGaugeResponse",
  [],
);

